const states = {
    isDimmed: 'is-dimmed',
    isDimmedUnderNav: 'is-dimmed-under-nav',
};

const dimElement = document.documentElement;

export function dim (underNavigation = false) {
    dimElement.classList.add(states.isDimmed);
    if (underNavigation) {
        dimElement.classList.add(states.isDimmedUnderNav);
    }
}

export function undim () {
    dimElement.classList.remove(states.isDimmed);
    if (dimElement.classList.contains(states.isDimmedUnderNav)) {
        dimElement.classList.remove(states.isDimmedUnderNav);
    }
}
